export function getCurrencySymbol(value: string) {
  const currencies: Record<string, string> = {
    USD: '\u0024',
    GBP: '\u00A3',
    EUR: '\u20AC',
  };

  return currencies[value] || '\u00A3';
}
